import { IonButton, IonText } from '@ionic/react';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';

const DOCUMENTATION_URL = process.env.REACT_APP_DOCUMENTATION_URL;

export function UserDocumentation() {
	const { t } = useTranslation();

	return !isNil(DOCUMENTATION_URL) ? (
		<IonButton
			expand="block"
			href={DOCUMENTATION_URL}
			target='_blank'
		>
			{t("userSettings.userDocumentation")}
		</IonButton>
	) : (
		<div style={{
			padding: "1em",
			textAlign: "center",
		}}>
			<IonText
				color="dark"
				>
				{t("userSettings.userDocumentationUrlNotConfigured")}
			</IonText>
		</div>
		);
}
